var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Suspense, useState } from 'react';
import { commonDateFieldValidation, commonDateValidations, getEndDate, getStartDate } from '../../AlmeUtilities/dateutils';
import { LazyDatepickerControl } from '../../Custom/Datepicker/LazyDatepickerControl';
import AlmeLoader from '../../AlmeLoader/AlmeLoader';
const InlineDatepicker = (_a) => {
    var { responseAction, responseRevision, onChange, value } = _a, props = __rest(_a, ["responseAction", "responseRevision", "onChange", "value"]);
    const [error, setError] = useState("");
    const [minDate] = useState(() => getStartDate((responseAction.MinDays === "" ? NaN : +responseAction.MinDays)));
    const [maxDate] = useState(() => getEndDate((responseAction.MaxDays === "" ? NaN : +responseAction.MaxDays)));
    const calendarProps = {
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select",
        shouldCloseOnSelect: false,
        adjustDateOnChange: true,
    };
    const onDateChange = (date) => {
        const errorObj = commonDateValidations(date, true, minDate, maxDate);
        onChange({ value: date, valid: !errorObj });
        setError(errorObj);
    };
    const onBlur = (dateString) => {
        const errorObj = commonDateFieldValidation(dateString, true);
        if (errorObj) {
            onChange({ value: null, valid: false });
            setError(errorObj);
        }
    };
    return (React.createElement(Suspense, { fallback: React.createElement(AlmeLoader, { loaded: false }) },
        React.createElement(LazyDatepickerControl, Object.assign({ id: `inline-date-picker-${responseRevision}`, value: value, minDate: minDate, maxDate: maxDate, onChange: onDateChange, onBlur: onBlur, placeholder: responseAction.TitleText, isDisabled: props.disabled, error: error, overlay: true, showCalendar: !responseAction.noCalendar }, calendarProps, props))));
};
export default InlineDatepicker;
